<script setup lang="ts">
import { ref } from "vue";
import RvApi from "@/rvapi";
import type { User } from "@/rvapi";
import { utc2local } from "@/utils";

const emit = defineEmits<{
  (e: "userSelected", userId: string): void;
}>();

const users = ref([] as User[]);
const searching = ref(false);
const onSearch = async (e: CustomEvent<string>) => {
  searching.value = true;
  const cloud = await RvApi.searchFreetext(e.detail);
  users.value = cloud.users;
  searching.value = false;
};
</script>

<template>
  <h1>Determine user to receiver balance</h1>
  <p>
    Please ensure the receiving user is the same person that has access to the
    device with balance.
  </p>
  <div>
    <pn-search-field
      name="query"
      placeholder="Email"
      v-on:search="onSearch"
      :loading="searching"
      label=""
    >
    </pn-search-field>
    <p v-show="users.length === 0">...</p>
    <p>
      <pn-table
        v-show="!searching && users.length > 0"
        bordered="true"
        striped="true"
      >
        <table>
          <thead>
            <tr>
              <th>Email</th>
              <th>Id</th>
              <th>Latest login</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.userId">
              <td>{{ user.email }}</td>
              <td>{{ user.userId }}</td>
              <td>{{ utc2local(user.lastLoginAt) }}</td>
              <td>
                <pn-button @click="emit('userSelected', user.userId)">
                  Migrate to this user
                </pn-button>
              </td>
            </tr>
          </tbody>
        </table>
      </pn-table>
    </p>
  </div>
</template>
